import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { BookView, getBookOptions } from '@/module/Author/Book';

export const Route = createFileRoute('/_auth/author/_author/book/_book/$bookId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { bookId } = Route.useParams();
  const { data: book } = useSuspenseQuery(getBookOptions(bookId));

  return <BookView book={book} />;
}
